
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"51","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","width":"50","height":"50","rx":"25"}}),_c('path',{attrs:{"d":"M29.833 25l5.188-5.187a3.062 3.062 0 000-4.333 3.062 3.062 0 00-4.334 0L25.5 20.666l-5.188-5.188a3.062 3.062 0 00-4.333 0 3.062 3.062 0 000 4.334L21.167 25l-5.188 5.188a3.08 3.08 0 000 4.333 3.07 3.07 0 004.333 0l5.188-5.187 5.187 5.187a3.071 3.071 0 004.334 0 3.08 3.08 0 000-4.333L29.833 25z","fill":"#fff"}})])
          )
        }
      }
    